export default "__VITE_ASSET__CppoSzmM__"